import {Injectable} from '@angular/core';
import {ApiReqHandlersService} from 'src/app/Shared/services/app-services/api-req-handlers.service';
import {API_URLS} from 'src/app/Shared/utilities/app-urls';


@Injectable({
    providedIn: 'root'
})
export class AuthService {
    constructor(private readonly _apiService: ApiReqHandlersService) {
    }

    /**
     *
     * @param payload
     */
    public login(payload: any) {
        console.log(payload);
        return this._apiService.post(`${API_URLS.authService.login}`, payload);
    }

    public logout() {
        return this._apiService.post(`${API_URLS.authService.logout}`);
    }

    /**
     *
     * @param payload
     */
    public resetPassword(payload: any) {
        return this._apiService.post(`${API_URLS.authService.password}/create`, payload);
    }
    public setPassword(payload: any) {
        return this._apiService.post(`${API_URLS.authService.password}/reset`, payload);
    }
}
